// extracted by mini-css-extract-plugin
export var card = "_ny-0";
export var content = "_ny-2";
export var icon = "_ny-1";